import {svgIconWrapper} from '../svg-icon-wrapper';

import MicrosoftRegular from './microsoft-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <MicrosoftRegular {...props} />;
}

SvgComponent.iconName = 'microsoftRegular';

export const MicrosoftRegularIcon = svgIconWrapper(SvgComponent);
